import React from 'react';
import i18n from 'utils/i18n';
// import getConfig from 'next/config';
import { PageProvider } from 'providers/page';
import SplashScreen from 'components/organisms/splash-screen';
import { useAuth } from 'providers/auth';

import css from './styles.module.scss';

let SPAEl = null;

const minTimeDelay = new Promise(resolve => {
  setTimeout(resolve, 2000);
});

function Index (props) {

  const audioRef = React.useRef();

  const {
    auth,
    ...other
  } = props;

  const {
    loading,
    data
  } = useAuth();

  const [showSplashScreen, setShowSplashScreen] = React.useState(true);
  const [showLoginForm, setShowLoginForm] = React.useState(false);
  const [SPAReady, setSPAReady] = React.useState(null);

  async function loadSPADependencies() {
    const SPA = (await import('components/organisms/spa')).default;
    SPAEl = SPA;
  }

  React.useEffect(_ => {
    async function startup () {
      if (data.loading) {
        return;
      }

      if (!data.isAuthenticated) {
        setShowLoginForm(true);
        setShowSplashScreen(true);
        setSPAReady(false);
      } else {
        // user IS authenticated
        if (data.user) {
          await Promise.all([
            loadSPADependencies(),
            minTimeDelay
          ]);

          if (!SPAReady) {
            if (localStorage.getItem('audioPlayed') !== '1') {
              audioRef.current.volume = .5;
              audioRef.current.play();
              localStorage.setItem('audioPlayed', '1');
            }
          }

          setSPAReady(true);
          setTimeout((_) => {
            setShowSplashScreen(false);
          }, 250);
        } else {
          setSPAReady(false);
          setShowSplashScreen(true);
        }
      }
    }

    startup();
  }, [data]);

  return (
    <div className={css['page__homeContainer']} data-page-container="1">
      {/* eslint-disable jsx-a11y/media-has-caption */}
      <audio className={css['audio-component']} ref={audioRef}>
        <source src="/audios/amos-intro-audio.mp3" type="audio/mpeg" />
        <source src="/audios/amos-intro-audio.ogg" type="audio/ogg" />
      </audio>

      {SPAReady && <SPAEl />}
      {showSplashScreen && (
        <SplashScreen
          className={css['splash-screen-container']}
          data-fading={SPAReady ? 1 : null}
          showButton={!!showLoginForm}
          loading={loading}
          auth={auth}
        />
      )}
    </div>
  );
}

export default function IndexPage(props) {
  const { children, ...other } = props;
  return (
    <PageProvider>
      <Index {...other} />
      {children}
    </PageProvider>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      messages: await i18n.getMessages(locale)
    }
  };
}
